<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Acknowledgments</h2>
<p class="noindent">I shall begin with a sincere appreciation to mom and dad who raised me in a village with very limited resources. Special thanks go to my uncle and aunt who hosted me for three years in a small three-bedroom house despite having ten children of their own. Perhaps, if it were not for their very kind support, I would still be a shepherd in the village. I shared the draft manuscript with many individuals. I particularly appreciate very helpful feedback from Dr.Muhammed Bozdag and Dr.Mahshid Turner, Sarah Aljuraywi, Yousef Aseafan, Sabreen Abdulrahman, Sultan Alshathri, and Sadeem Alsofyani. I am really in debt to my professional editor, Katharine Worthington for her great editing and helpful input. Finally, many thanks to Morgan James Publishing team and its CEO, David Hancock, for their excellent guidance and great support during the publication process. While I acknowledge with gratitude my debt to these colleagues, I must emphasize that I, alone, am responsible for any mistakes and shortcomings in this book. And above all, for her sacrifices and shared responsibilities for 25 years, special thanks to my wife, Aynur, and our six children: Nurefsan, Berfinnur, Aishanur, Fatma Zehra, Kubranur, and Ibrahim Said.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?684187bc